import React, { memo } from "react";

import { useTranslation } from "react-i18next";

import { useReduxSelector } from "@hooks/useReduxSelector";
import { Controller, useForm } from "react-hook-form";

import Loupe from "@assets/image/icones/employer/loup.svg";

import InputLoupe from "@components/input/InputIcone";
import { ListboxSimple } from "@components/tailwindComponents";
import Button from "@components/tailwindComponents/Button";

function Filter(props) {
  const { t: translator } = useTranslation("assesment.frequency");
  const { control, handleSubmit } = useForm();

  const { individualObjectiveType, individualObjectivePeriod } =
    useReduxSelector(({ developmentPlan }) => developmentPlan);

  function handleSuccess(formValue) {
    props.setFilterValue({
      nameSearch: formValue.nameSearch,
      objectivePeriods: formValue.objectivePeriods.map(
        (objectivePeriod) => objectivePeriod._id
      ),
      objectiveTypes: formValue.objectiveTypes.map(
        (objectiveType) => objectiveType._id
      )
    });
  }

  return (
    <div className="arh-mt-5 arh-w-full arh-rounded arh-bg-greyColor arh-p-4">
      <div className="arh-grid arh-grid-cols-4 arh-gap-10">
        <div className="">
          <Controller
            control={control}
            name="nameSearch"
            defaultValue=""
            render={({ field: { onChange, value, name } }) => (
              <InputLoupe
                text={translator("Champ de recherche")}
                src={Loupe}
                value={value}
                onChange={onChange}
                classInputLoup="!arh-pl-9"
                showReset={true}
                name={name}
                onClickReset={() => onChange("")}
              />
            )}
          />
        </div>

        <div className="">
          <Controller
            control={control}
            name="objectivePeriods"
            defaultValue={[]}
            render={({ field: { onChange, value, name } }) => (
              <ListboxSimple
                placeholder={translator("Périodes visées")}
                name={name}
                optionList={individualObjectivePeriod.list}
                selectedValue={value}
                setSelectedValue={onChange}
                showReset={true}
                multiple={true}
                withTooltip={true}
              />
            )}
          />
        </div>

        <div className="">
          <Controller
            control={control}
            name="objectiveTypes"
            defaultValue={[]}
            render={({ field: { onChange, value, name } }) => (
              <ListboxSimple
                placeholder={translator("Types")}
                name={name}
                optionList={individualObjectiveType.list}
                selectedValue={value}
                setSelectedValue={onChange}
                showReset={true}
                multiple={true}
                withTooltip={true}
              />
            )}
          />
        </div>
        <div className="">
          <Button onClick={handleSubmit(handleSuccess)}>
            {translator("Appliquer")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default memo(Filter);
